<template>
	<div class="fixed inset-y-0 right-0 flex side-over z-50 w-sideover">
		<div class="h-full w-full flex flex-col bg-white shadow-xl">
			<div class="px-6 py-8 bg-blue-50">
				<div class="flex items-start justify-between">
					<div class="flex items-center gap-2">
						<svg
							width="24"
							height="24"
							viewBox="0 0 24 24"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								fill-rule="evenodd"
								clip-rule="evenodd"
								d="M6 0.75C6 0.335786 5.66421 0 5.25 0C4.83579 0 4.5 0.335786 4.5 0.75V1.5H3C1.34315 1.5 0 2.84315 0 4.5V6H24V4.5C24 2.84315 22.6569 1.5 21 1.5H19.5V0.75C19.5 0.335786 19.1642 0 18.75 0C18.3358 0 18 0.335786 18 0.75V1.5H6V0.75ZM24 21V7.5H0V21C0 22.6569 1.34315 24 3 24H21C22.6569 24 24 22.6569 24 21ZM14.25 10.5C13.8358 10.5 13.5 10.8358 13.5 11.25V12.75C13.5 13.1642 13.8358 13.5 14.25 13.5H15.75C16.1642 13.5 16.5 13.1642 16.5 12.75V11.25C16.5 10.8358 16.1642 10.5 15.75 10.5H14.25ZM18.75 10.5C18.3358 10.5 18 10.8358 18 11.25V12.75C18 13.1642 18.3358 13.5 18.75 13.5H20.25C20.6642 13.5 21 13.1642 21 12.75V11.25C21 10.8358 20.6642 10.5 20.25 10.5H18.75ZM3 15.75C3 15.3358 3.33579 15 3.75 15H5.25C5.66421 15 6 15.3358 6 15.75V17.25C6 17.6642 5.66421 18 5.25 18H3.75C3.33579 18 3 17.6642 3 17.25V15.75ZM8.25 15C7.83579 15 7.5 15.3358 7.5 15.75V17.25C7.5 17.6642 7.83579 18 8.25 18H9.75C10.1642 18 10.5 17.6642 10.5 17.25V15.75C10.5 15.3358 10.1642 15 9.75 15H8.25Z"
								fill="#94A3B8"
							/>
						</svg>
						<div class="text-4xl font-bold text-neutral-700 ml-1.5">
							Thống kê chuyên cần
						</div>
					</div>
					<div class="ml-3 h-7 flex items-center">
						<button
							type="button"
							class="
								rounded-md
								text-neutral-400
								hover:text-neutral-700
							"
							@click="$emit('close')"
						>
							<span class="sr-only">Close panel</span>
							<svg
								class="h-6 w-6"
								xmlns="http://www.w3.org/2000/svg"
								fill="none"
								viewBox="0 0 24 24"
								stroke="currentColor"
								aria-hidden="true"
							>
								<path
									stroke-linecap="round"
									stroke-linejoin="round"
									stroke-width="2"
									d="M6 18L18 6M6 6l12 12"
								/>
							</svg>
						</button>
					</div>
				</div>
			</div>
			<div class="relative flex-1 px-4 sm:px-6 overflow-y-auto pb-8">
				<div class="py-8 flex justify-between items-center w-full">
					<router-link :to="`/record/student/${student?.id}`">
						<div class="flex items-center">
							<div class="relative">
								<img
									alt=""
									style="min-width: 56px"
									class="
										shadow-sm
										inline-statistic
										h-14
										w-14
										rounded-full
									"
									:src="student?.profile_photo?.w200"
									v-if="student?.profile_photo?.w200"
								/>
								<span
									style="min-width: 56px"
									v-else
									class="
										inline-flex
										items-center
										justify-center
										h-14
										w-14
										rounded-full
									"
									:style="{
										background:
											student?.profile_photo?.default
												?.color,
									}"
								>
									<span
										class="
											font-medium
											leading-none
											text-white text-4xl
										"
										>{{
											student?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div
									v-if="student?.state !== 'active'"
									class="
										absolute
										transform
										-translate-x-1/2 -translate-y-1/2
										top-1/2
										left-1/2
										h-14
										w-14
										rounded-full
										flex
										items-center
										justify-center
									"
									style="
										background-color: rgba(
											241,
											162,
											103,
											0.5
										);
									"
								>
									<svg
										v-if="student?.state === 'pending'"
										width="14"
										height="14"
										viewBox="0 0 14 14"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M13.4615 7.00011C13.4615 10.5687 10.5686 13.4617 6.99999 13.4617C3.43138 13.4617 0.538452 10.5687 0.538452 7.00011C0.538452 3.4315 3.43138 0.538574 6.99999 0.538574C10.5686 0.538574 13.4615 3.4315 13.4615 7.00011ZM6.99999 3.3655C6.99999 3.14246 6.81918 2.96165 6.59614 2.96165C6.37311 2.96165 6.1923 3.14246 6.1923 3.3655V7.80781C6.1923 7.95273 6.26995 8.08654 6.39578 8.15844L9.2227 9.77383C9.41636 9.88449 9.66305 9.81721 9.7737 9.62355C9.88436 9.4299 9.81708 9.18321 9.62343 9.07255L6.99999 7.57344V3.3655Z"
											fill="white"
										/>
									</svg>
									<svg
										v-else-if="
											student?.state === 'archived'
										"
										width="14"
										height="14"
										viewBox="0 0 14 14"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											fill-rule="evenodd"
											clip-rule="evenodd"
											d="M4.56127 3.76863C4.43858 3.76863 4.32255 3.8244 4.24592 3.9202L1.78255 6.9994H5.38461C5.60765 6.9994 5.78845 7.18021 5.78845 7.40325C5.78845 8.07236 6.33088 8.61478 6.99999 8.61478C7.66911 8.61478 8.21153 8.07236 8.21153 7.40325C8.21153 7.18021 8.39234 6.9994 8.61538 6.9994H12.2174L9.75407 3.9202C9.67743 3.8244 9.5614 3.76863 9.43872 3.76863H4.56127ZM3.61521 3.41563C3.84513 3.12824 4.19322 2.96094 4.56127 2.96094H9.43872C9.80676 2.96094 10.1549 3.12824 10.3848 3.41563L13.373 7.15096C13.4411 7.2361 13.4719 7.34515 13.4584 7.45334L13.143 9.9766C13.0672 10.5829 12.5518 11.0379 11.9408 11.0379H2.05916C1.44816 11.0379 0.932766 10.5829 0.85698 9.9766L0.541572 7.45334C0.52805 7.34515 0.558842 7.2361 0.626949 7.15096L3.61521 3.41563Z"
											fill="white"
										/>
									</svg>
									<svg
										v-else
										fill="none"
										height="14"
										viewBox="0 0 40 40"
										width="14"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											clip-rule="evenodd"
											d="M9.84364 16.0997V10.2496C9.84364 4.86466 14.3907 0.5 20 0.5C25.6093 0.5 30.1564 4.865 30.1564 10.2496V16.0997C33.5218 16.0997 36.25 18.7188 36.25 21.9497V33.6499C36.25 36.8812 33.5218 39.5 30.1564 39.5H9.84364C6.47821 39.5 3.75 36.8812 3.75 33.6499V21.9497C3.75 18.7188 6.47821 16.0997 9.84364 16.0997V16.0997ZM26.0936 16.0997V10.2496C26.0936 7.01866 23.3654 4.3995 20 4.3995C16.6346 4.3995 13.9064 7.01866 13.9064 10.2496V16.0997H26.0936ZM20 23.9C21.1218 23.9 22.0311 24.7729 22.0311 25.8499V29.7501C22.0311 30.8271 21.1218 31.7 20 31.7C18.8782 31.7 17.9689 30.8271 17.9689 29.7501V25.8499C17.9689 24.7729 18.8782 23.9 20 23.9Z"
											fill="#FAF5F1"
											fill-rule="evenodd"
										/>
									</svg>
								</div>
							</div>
							<div class="ml-4">
								<div
									class="
										font-bold
										text-neutral-700 text-4xl
										md-down:text-2xl
									"
								>
									{{ student?.name }}
								</div>
								<div
									v-if="student?.state === 'stopped'"
									class="
										text-green-500
										font-semibold
										text-xs
										uppercase
									"
								>
									XIN NGHỈ
								</div>
								<div
									v-if="
										student?.age &&
										student?.state !== 'stopped'
									"
									class="
										text-green-500
										font-semibold
										text-xs
										uppercase
									"
								>
									{{ student?.age }}
									{{
										student?.learning_time
											? `| ${student?.learning_time}`
											: ''
									}}
								</div>
							</div>
						</div>
					</router-link>
				</div>
				<div class="mb-10">
					<div class="flex items-center justify-between mb-4">
						<div class="flex items-center gap-2">
							<img
								src="@/assets/images/icons/white-class-teacher.png"
								alt=""
							/>

							<div
								class="font-semibold text-base text-neutral-600"
							>
								Thống kê học can thiệp cá nhân
							</div>
						</div>
						<div
							class="
								font-semibold
								text-sm text-yellow-700
								cursor-pointer
							"
							@click="
								router.push(
									`/schedule/stats/student?student_id=${id}&date=${monthStart}`
								)
							"
						>
							Xem chi tiết
						</div>
					</div>
					<div class="flex items-center gap-2 flex-wrap">
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-start gap-2">
								<img
									class="mt-1"
									src="@/assets/images/icons/clock-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ học thực tế/dự kiến<br />
									tháng {{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.session_stats?.this_month
										?.total_non_cancelled_hours
								}}/{{
									statistics?.session_stats?.this_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ học dự kiến tháng
									{{ month + 1 }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.session_stats?.next_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-extra-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ học phát sinh tháng
									{{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.session_stats?.this_month
										?.total_unscheduled_hours || 0
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-off-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ nghỉ tháng {{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.session_stats?.this_month
										?.total_cancelled_hours
								}}/{{
									statistics?.session_stats?.this_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-off-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ nghỉ tháng {{ month - 1 }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.session_stats?.last_month
										?.total_cancelled_hours
								}}/{{
									statistics?.session_stats?.last_month
										?.total_hours
								}}
							</div>
						</div>
					</div>
				</div>
				<div class="mb-10">
					<div class="flex items-center justify-between mb-4">
						<div class="flex items-center gap-2">
							<img
								class="w-5 h-5"
								src="@/assets/images/icons/people-fill.png"
								alt=""
							/>

							<div
								class="font-semibold text-base text-neutral-600"
							>
								Thống kê học can thiệp lớp nhóm
							</div>
						</div>
						<div
							class="
								font-semibold
								text-sm text-yellow-700
								cursor-pointer
							"
							@click="
								router.push(
									`/schedule/stats/student/group-class?student_id=${id}&date=${monthStart}`
								)
							"
						>
							Xem chi tiết
						</div>
					</div>
					<div class="flex items-center gap-2 flex-wrap">
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-start gap-2">
								<img
									class="mt-1"
									src="@/assets/images/icons/clock-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ học thực tế/dự kiến<br />
									tháng {{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.group_class_stats?.this_month
										?.total_non_cancelled_hours
								}}/{{
									statistics?.group_class_stats?.this_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ học dự kiến tháng
									{{ month + 1 }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.group_class_stats?.next_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-extra-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ học phát sinh tháng
									{{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.group_class_stats?.this_month
										?.total_unscheduled_hours || 0
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-off-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ nghỉ tháng {{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.group_class_stats?.this_month
										?.total_cancelled_hours
								}}/{{
									statistics?.group_class_stats?.this_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/clock-off-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ nghỉ tháng {{ month - 1 }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.group_class_stats?.last_month
										?.total_cancelled_hours
								}}/{{
									statistics?.group_class_stats?.last_month
										?.total_hours
								}}
							</div>
						</div>
					</div>
				</div>
				<div>
					<div class="flex items-center justify-between mb-4">
						<div class="flex items-center gap-2">
							<img
								src="@/assets/images/icons/white-spoon.png"
								alt=""
							/>

							<div
								class="font-semibold text-base text-neutral-600"
							>
								Thống kê học bán trú
							</div>
						</div>
						<div
							class="
								font-semibold
								text-sm text-yellow-700
								cursor-pointer
							"
							@click="
								router.push(
									`/schedule/stats/student/daycare?student_id=${id}&date=${monthStart}`
								)
							"
						>
							Xem chi tiết
						</div>
					</div>
					<div class="flex items-center gap-2 flex-wrap">
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-start gap-2">
								<img
									class="mt-1"
									src="@/assets/images/icons/calendar-check-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số ngày học thực tế/dự kiến<br />
									tháng {{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.day_care_stats?.this_month
										?.total_non_cancelled_hours
								}}/{{
									statistics?.day_care_stats?.this_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/calendar-week-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số ngày học dự kiến tháng
									{{ month + 1 }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.day_care_stats?.next_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/calendar-plus-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ học phát sinh tháng
									{{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.day_care_stats?.this_month
										?.total_unscheduled_hours || 0
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/calendar-minus-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số giờ nghỉ tháng {{ month }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.day_care_stats?.this_month
										?.total_cancelled_hours
								}}/{{
									statistics?.day_care_stats?.this_month
										?.total_hours
								}}
							</div>
						</div>
						<div
							class="
								statistic
								w-full
								flex
								items-center
								justify-between
							"
						>
							<div class="flex items-center gap-2">
								<img
									src="@/assets/images/icons/calendar-minus-fill.png"
									alt=""
								/>
								<div
									class="
										font-normal
										text-base text-neutral-500
									"
								>
									Số ngày nghỉ tháng {{ month - 1 }}/2025
								</div>
							</div>
							<div class="font-bold text-neutral-600 text-3xl">
								{{
									statistics?.day_care_stats?.last_month
										?.total_cancelled_hours
								}}/{{
									statistics?.day_care_stats?.last_month
										?.total_hours
								}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useRoute } from 'vue-router';
import { useStudent } from '@/features/student/useStudent';
import { $api } from '@/services';
import router from '@/router';

const route = useRoute();
const id = ref(route.query.id);
const month = ref('');
const monthStart = ref(route.query.month_start);
const student = ref(null);
const statistics = ref({});
const { getStudent } = useStudent();

onMounted(() => {
	fetchStudent();
	getStudentStatistics();
});

async function fetchStudent() {
	const res = await getStudent(id.value);
	if (res?.data) {
		student.value = res?.data;
	}
}
async function getStudentStatistics() {
	try {
		const res = await $api.org.getStudentStatistics(Number(id.value), {
			month_start: monthStart.value,
		});
		statistics.value = res.data.data;
		let date = new Date(monthStart.value);
		month.value = date.getMonth() + 1;
	} catch (error) {
		console.log(error);
	}
}
</script>
<style scoped>
.w-sideover {
	width: 448px;
}
.statistic {
	border-radius: 8px;
	padding: 16px;
	border: 1px solid #e1e7ef;
}
@media only screen and (max-width: 768px) {
	.w-sideover {
		width: 100%;
	}
}
</style>
